export { Logomark } from './Logomark'
export { VisualPattern } from './VisualPattern'
